import request from '@/utils/request'

export function sendLogin (data, headers) {
  return request({
    url: '/utsvInternet/internet/api/client/login',
    method: 'POST',
    headers,
    data
  })
}

/* 重复登陆 */
export function concurrentLoginApi (data, headers) {
  return request({
    url: '/utsvInternet/internet/api/client/concurrent',
    method: 'POST',
    headers,
    data
  })
}

/* 登出 */
export function utsvLogoutApi (type, headers) {
  /*
    manual: 点击退出
    timesUp: 超时
  */
  return request({
    url: '/utsvInternet/internet/api/client/logout?&type=' + type,
    method: 'GET',
    headers
  })
}

export function getEventDetailApi (eventId, headers) {
  return request({
    url: `/utsvInternet/internet/api/event/${eventId}?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getPerformancesApi (eventId, headers) {
  return request({
    url: `/utsvInternet/internet/api/event/${eventId}/performances?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getPriceListApi (event, perfid, headers) {
  return request({
    url: `/utsvInternet/internet/api/event/${event}/performance/${perfid}/pricezones?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getStatusApi (headers) {
  return request({
    url: `/utsvInternet/internet/api/client/status?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getDeliveriesApi (headers) {
  return request({
    url: `/utsvInternet/internet/api/orders/deliveries?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getPaymentsApi (headers) {
  return request({
    url: `/utsvInternet/internet/api/orders/payments?=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function setHoldSeat (eventId, perfId, params, headers) {
  return request({
    url: `/utsvInternet/internet/api/event/${eventId}/performance/${perfId}/holdseat`,
    method: 'POST',
    headers,
    data: params
  })
}

export function getOrdersApi (headers) {
  return request({
    url: `/utsvInternet/internet/api/orders?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getCountriesApi (deliveryId, headers) {
  return request({
    url: `/utsvInternet/internet/api/delivery/${deliveryId}/countries?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getRegionsApi (deliveryId, countryId, headers) {
  return request({
    url: `/internet/api/delivery/${deliveryId}/country/${countryId}/regions?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function setOrders (params, headers) {
  return request({
    url: '/utsvInternet/internet/api/orders/mailing',
    method: 'POST',
    headers,
    data: params
  })
}

export function getOrdersWithRemarksApi (headers) {
  return request({
    url: `/utsvInternet/internet/api/orders/withRemarks?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function payApi (params, headers) {
  return request({
    url: '/utsvInternet/internet/api/orders/pay',
    method: 'POST',
    headers,
    data: params
  })
}

export function getOrderCompleteApi (params, headers) {
  return request({
    url: '/utsvInternet/internet/api/orders/complete',
    method: 'POST',
    headers,
    data: params
  })
}

export function getConfigApi (headers) {
  return request({
    url: `/utsvInternet/internet/api/config?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getActivityLabelGroupApi (headers) {
  return request({
    url: `/utsvInternet/internet/api/labelGroup?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

export function getEventLabelGroupApi (eventId, headers) {
  return request({
    url: `/utsvInternet/internet/api/event/${eventId}/labelGroup?_=${Date.now()}`,
    method: 'GET',
    headers
  })
}

// 获取 选中座位区域 的坐标点
export function getPartOfHousesApi (eventId, perfId, headers) {
  // https://utsvstg.cityline.com/utsvInternet/internet/api/event/38223/performance/59394/partOfHouses?_=1690786995681
  return new Promise((resolve) => {
    resolve({
      "partOfHouses": [
        {
          "partOfHouseId": 20832,
          "house": "BLOCK 7",
          "color": "#FFFF00",
          "pricezoneIds": [
            660,
            1068
          ],
          "points": [
            {
              "x": 66,
              "y": 460
            },
            {
              "x": 166,
              "y": 460
            },
            {
              "x": 165,
              "y": 486
            },
            {
              "x": 151,
              "y": 502
            },
            {
              "x": 142,
              "y": 498
            },
            {
              "x": 128,
              "y": 511
            },
            {
              "x": 124,
              "y": 509
            },
            {
              "x": 119,
              "y": 511
            },
            {
              "x": 87,
              "y": 544
            },
            {
              "x": 70,
              "y": 528
            }
          ]
        },
        {
          "partOfHouseId": 20833,
          "house": "BLOCK 9",
          "color": "#FFFF00",
          "pricezoneIds": [
            660
          ],
          "points": [
            {
              "x": 219,
              "y": 525
            },
            {
              "x": 218,
              "y": 569
            },
            {
              "x": 215,
              "y": 596
            },
            {
              "x": 215,
              "y": 622
            },
            {
              "x": 319,
              "y": 622
            },
            {
              "x": 318,
              "y": 597
            },
            {
              "x": 318,
              "y": 568
            },
            {
              "x": 317,
              "y": 524
            }
          ]
        },
        {
          "partOfHouseId": 20834,
          "house": "WZ 8",
          "color": "#00FF00",
          "pricezoneIds": [
            335
          ],
          "points": [
            {
              "x": 54,
              "y": 360
            },
            {
              "x": 60,
              "y": 360
            },
            {
              "x": 60,
              "y": 410
            },
            {
              "x": 54,
              "y": 410
            }
          ]
        },
        {
          "partOfHouseId": 20835,
          "house": "BLOCK 15",
          "color": "#FFFF00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 364,
              "y": 218
            },
            {
              "x": 466,
              "y": 218
            },
            {
              "x": 466,
              "y": 163
            },
            {
              "x": 364,
              "y": 163
            }
          ]
        },
        {
          "partOfHouseId": 20836,
          "house": "BLOCK 3",
          "color": "#FFFF00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 66,
              "y": 162
            },
            {
              "x": 167,
              "y": 161
            },
            {
              "x": 168,
              "y": 222
            },
            {
              "x": 67,
              "y": 223
            }
          ]
        },
        {
          "partOfHouseId": 20837,
          "house": "BLOCK 4",
          "color": "#FFFF00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 68,
              "y": 230
            },
            {
              "x": 168,
              "y": 230
            },
            {
              "x": 168,
              "y": 300
            },
            {
              "x": 68,
              "y": 300
            }
          ]
        },
        {
          "partOfHouseId": 20838,
          "house": "BLOCK 5",
          "color": "#FFFF00",
          "pricezoneIds": [
            660
          ],
          "points": [
            {
              "x": 67,
              "y": 312
            },
            {
              "x": 169,
              "y": 312
            },
            {
              "x": 169,
              "y": 376
            },
            {
              "x": 65,
              "y": 375
            }
          ]
        },
        {
          "partOfHouseId": 20839,
          "house": "BLOCK 6",
          "color": "#FFFF00",
          "pricezoneIds": [
            660,
            1068
          ],
          "points": [
            {
              "x": 66,
              "y": 389
            },
            {
              "x": 168,
              "y": 389
            },
            {
              "x": 167,
              "y": 449
            },
            {
              "x": 67,
              "y": 450
            }
          ]
        },
        {
          "partOfHouseId": 20818,
          "house": "BLOCK 8",
          "color": "#FFFF00",
          "pricezoneIds": [
            829,
            1068
          ],
          "points": [
            {
              "x": 180,
              "y": 498
            },
            {
              "x": 160,
              "y": 516
            },
            {
              "x": 154,
              "y": 509
            },
            {
              "x": 132,
              "y": 530
            },
            {
              "x": 128,
              "y": 525
            },
            {
              "x": 95,
              "y": 558
            },
            {
              "x": 166,
              "y": 624
            },
            {
              "x": 208,
              "y": 624
            },
            {
              "x": 209,
              "y": 534
            },
            {
              "x": 208,
              "y": 524
            }
          ]
        },
        {
          "partOfHouseId": 20819,
          "house": "BLOCK A",
          "color": "#ffff00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 190,
              "y": 198
            },
            {
              "x": 190,
              "y": 98
            },
            {
              "x": 346,
              "y": 98
            },
            {
              "x": 346,
              "y": 196
            }
          ]
        },
        {
          "partOfHouseId": 20820,
          "house": "BLOCK D",
          "color": "#ffff00",
          "pricezoneIds": [
            660
          ],
          "points": [
            {
              "x": 183,
              "y": 430
            },
            {
              "x": 183,
              "y": 490
            },
            {
              "x": 341,
              "y": 490
            },
            {
              "x": 341,
              "y": 427
            }
          ]
        },
        {
          "partOfHouseId": 20821,
          "house": "BLOCK 2",
          "color": "#ffff00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 66,
              "y": 152
            },
            {
              "x": 66,
              "y": 98
            },
            {
              "x": 168,
              "y": 98
            },
            {
              "x": 168,
              "y": 152
            }
          ]
        },
        {
          "partOfHouseId": 20822,
          "house": "BLOCK 1",
          "color": "#ffff00",
          "pricezoneIds": [
            13792
          ],
          "points": [
            {
              "x": 68,
              "y": 84
            },
            {
              "x": 68,
              "y": 34
            },
            {
              "x": 172,
              "y": 34
            },
            {
              "x": 172,
              "y": 84
            }
          ]
        },
        {
          "partOfHouseId": 20823,
          "house": "BLOCK 17",
          "color": "#ffff00",
          "pricezoneIds": [
            13792
          ],
          "points": [
            {
              "x": 364,
              "y": 84
            },
            {
              "x": 364,
              "y": 36
            },
            {
              "x": 468,
              "y": 36
            },
            {
              "x": 468,
              "y": 85
            }
          ]
        },
        {
          "partOfHouseId": 20824,
          "house": "BLOCK 16",
          "color": "#ffff00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 364,
              "y": 150
            },
            {
              "x": 364,
              "y": 98
            },
            {
              "x": 466,
              "y": 98
            },
            {
              "x": 466,
              "y": 149
            }
          ]
        },
        {
          "partOfHouseId": 20825,
          "house": "BLOCK B",
          "color": "#ffff00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 188,
              "y": 210
            },
            {
              "x": 188,
              "y": 303
            },
            {
              "x": 347,
              "y": 305
            },
            {
              "x": 348,
              "y": 207
            }
          ]
        },
        {
          "partOfHouseId": 20826,
          "house": "BLOCK C",
          "color": "#ffff00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 188,
              "y": 320
            },
            {
              "x": 188,
              "y": 414
            },
            {
              "x": 342,
              "y": 414
            },
            {
              "x": 342,
              "y": 316
            }
          ]
        },
        {
          "partOfHouseId": 20827,
          "house": "BLOCK 10",
          "color": "#FFFF00",
          "pricezoneIds": [
            829,
            1068
          ],
          "points": [
            {
              "x": 328,
              "y": 520
            },
            {
              "x": 329,
              "y": 567
            },
            {
              "x": 330,
              "y": 589
            },
            {
              "x": 330,
              "y": 624
            },
            {
              "x": 367,
              "y": 623
            },
            {
              "x": 372,
              "y": 621
            },
            {
              "x": 436,
              "y": 554
            },
            {
              "x": 406,
              "y": 520
            },
            {
              "x": 394,
              "y": 518
            },
            {
              "x": 382,
              "y": 507
            },
            {
              "x": 376,
              "y": 511
            },
            {
              "x": 357,
              "y": 494
            }
          ]
        },
        {
          "partOfHouseId": 20828,
          "house": "BLOCK 11",
          "color": "#FFFF00",
          "pricezoneIds": [
            660,
            1068
          ],
          "points": [
            {
              "x": 362,
              "y": 493
            },
            {
              "x": 368,
              "y": 497
            },
            {
              "x": 379,
              "y": 508
            },
            {
              "x": 388,
              "y": 505
            },
            {
              "x": 402,
              "y": 517
            },
            {
              "x": 406,
              "y": 515
            },
            {
              "x": 412,
              "y": 519
            },
            {
              "x": 444,
              "y": 552
            },
            {
              "x": 464,
              "y": 536
            },
            {
              "x": 464,
              "y": 462
            },
            {
              "x": 358,
              "y": 462
            }
          ]
        },
        {
          "partOfHouseId": 20829,
          "house": "BLOCK 12",
          "color": "#FFFF00",
          "pricezoneIds": [
            660,
            1068
          ],
          "points": [
            {
              "x": 362,
              "y": 450
            },
            {
              "x": 466,
              "y": 449
            },
            {
              "x": 466,
              "y": 389
            },
            {
              "x": 362,
              "y": 388
            }
          ]
        },
        {
          "partOfHouseId": 20830,
          "house": "BLOCK 13",
          "color": "#FFFF00",
          "pricezoneIds": [
            660
          ],
          "points": [
            {
              "x": 362,
              "y": 378
            },
            {
              "x": 464,
              "y": 378
            },
            {
              "x": 464,
              "y": 310
            },
            {
              "x": 362,
              "y": 310
            }
          ]
        },
        {
          "partOfHouseId": 20831,
          "house": "BLOCK 14",
          "color": "#FFFF00",
          "pricezoneIds": [
            636
          ],
          "points": [
            {
              "x": 362,
              "y": 300
            },
            {
              "x": 468,
              "y": 299
            },
            {
              "x": 467,
              "y": 231
            },
            {
              "x": 363,
              "y": 231
            }
          ]
        }
      ]
    })
  })
  /* return request({
    url: `/utsvInternet/internet/api/event/${eventId}/performance/${perfId}/partOfHouses?_=${Date.now()}`,
    method: 'GET',
    headers
  }) */
}

// 获取 选中座位区域 的坐标点
export function getPriceZonesApi (eventId, perfId, headers) {
  // https://utsvstg.cityline.com/utsvInternet/internet/api/event/38223/performance/59394/pricezones?_=1690789451528
  return new Promise((resolve) => {
    resolve({pricezones: [
      {
          "pricezoneId": 636,
          "code": null,
          /* 按钮的颜色 */
          "color": "#FF4DE5",
          "nameEn": "A",
          "nameTc": "A",
          "nameSc": "A",
          "price": 200,
          "status": "AVAILABLE",
          "ticketTypes": [
              {
                  "tickettypeId": 100,
                  "tickettypeCode": "STAN",
                  "descriptionEn": "STANDARD",
                  "descriptionTc": "正價票",
                  "descriptionSc": "正价票",
                  "tickettypeNameEn": "STANDARD",
                  "tickettypeNameTc": "正價票",
                  "tickettypeNameSc": "正价票",
                  "quantity": 40,
                  "price": 200,
                  "boundType": null,
                  "boundQuantity": null,
                  "prerequisiteTicketTypeId": null
              }
          ]
      },
      {
          "pricezoneId": 660,
          "code": null,
          "color": "#FA930F",
          "nameEn": "B",
          "nameTc": "B",
          "nameSc": "B",
          "price": 1680,
          "status": "AVAILABLE",
          "ticketTypes": [
              {
                  "tickettypeId": 100,
                  "tickettypeCode": "STAN",
                  "descriptionEn": "STANDARD",
                  "descriptionTc": "正價票",
                  "descriptionSc": "正价票",
                  "tickettypeNameEn": "STANDARD",
                  "tickettypeNameTc": "正價票",
                  "tickettypeNameSc": "正价票",
                  "quantity": 40,
                  "price": 1680,
                  "boundType": null,
                  "boundQuantity": null,
                  "prerequisiteTicketTypeId": null
              }
          ]
      },
      {
          "pricezoneId": 1068,
          "code": null,
          "color": "#FD1CCF",
          "nameEn": "C",
          "nameTc": "C",
          "nameSc": "C",
          "price": 480,
          "status": "AVAILABLE",
          "ticketTypes": [
              {
                  "tickettypeId": 100,
                  "tickettypeCode": "STAN",
                  "descriptionEn": "STANDARD",
                  "descriptionTc": "正價票",
                  "descriptionSc": "正价票",
                  "tickettypeNameEn": "STANDARD",
                  "tickettypeNameTc": "正價票",
                  "tickettypeNameSc": "正价票",
                  "quantity": 40,
                  "price": 480,
                  "boundType": null,
                  "boundQuantity": null,
                  "prerequisiteTicketTypeId": null
              }
          ]
      },
      {
          "pricezoneId": 829,
          "code": null,
          "color": "#103AF9",
          "nameEn": "D",
          "nameTc": "D",
          "nameSc": "D",
          "price": 380,
          "status": "AVAILABLE",
          "ticketTypes": [
              {
                  "tickettypeId": 100,
                  "tickettypeCode": "STAN",
                  "descriptionEn": "STANDARD",
                  "descriptionTc": "正價票",
                  "descriptionSc": "正价票",
                  "tickettypeNameEn": "STANDARD",
                  "tickettypeNameTc": "正價票",
                  "tickettypeNameSc": "正价票",
                  "quantity": 40,
                  "price": 380,
                  "boundType": null,
                  "boundQuantity": null,
                  "prerequisiteTicketTypeId": null
              }
          ]
      },
      {
          "pricezoneId": 335,
          "code": null,
          "color": "#1EFA33",
          "nameEn": "Wheelchair Zone",
          "nameTc": "輪椅人士席",
          "nameSc": "轮椅人士席",
          "price": 1680,
          "status": "AVAILABLE",
          "ticketTypes": [
              {
                  "tickettypeId": 1250,
                  "tickettypeCode": "WZ",
                  "descriptionEn": "WHEELCHAIR USER",
                  "descriptionTc": "輪椅使用者",
                  "descriptionSc": "轮椅使用者",
                  "tickettypeNameEn": "WHEELCHAIR USER",
                  "tickettypeNameTc": "輪椅使用者",
                  "tickettypeNameSc": "轮椅使用者",
                  "quantity": 10,
                  "price": 1680,
                  "boundType": null,
                  "boundQuantity": null,
                  "prerequisiteTicketTypeId": null
              }
          ]
      }
  ]
  })
  })
  /* return request({
    url: `/utsvInternet/internet/api/event/${eventId}/performance/${perfId}/pricezones?_=${Date.now()}`,
    method: 'GET',
    headers
  }) */
}

export function getSeatsInfo (eventId, perfId, seatsId, headers) {
  // https://utsvstg.cityline.com/utsvInternet/internet/api/event/38223/performance/59394/pricezones?_=1690789451528
  return new Promise((resolve) => {
    resolve(
      {
        "perfId": 59394,
        "pohId": 20833,
        "status": 80000,
        "seatWidth": "16",
        "seatHeight": "16",
        "houseRemark": {
            "value": "STAGE 舞台",
            "x": 307,
            "y": 15
        },
        "remarkNList": [
            {
                "id": 0,
                "value": "STAGE 舞台",
                "x": 307,
                "y": 15
            },
            {
                "id": 1,
                "value": "BLOCK 9",
                "x": 325,
                "y": 490
            }
        ],
        "seatList": [
            {
                "id": 41920578,
                "x": "30",
                "y": "414",
                "row": "X",
                "col": "1",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920579,
                "x": "47",
                "y": "414",
                "row": "X",
                "col": "2",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920580,
                "x": "64",
                "y": "414",
                "row": "X",
                "col": "3",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920581,
                "x": "81",
                "y": "414",
                "row": "X",
                "col": "4",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920582,
                "x": "98",
                "y": "414",
                "row": "X",
                "col": "5",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920583,
                "x": "115",
                "y": "414",
                "row": "X",
                "col": "6",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920584,
                "x": "132",
                "y": "414",
                "row": "X",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920585,
                "x": "149",
                "y": "414",
                "row": "X",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920586,
                "x": "166",
                "y": "414",
                "row": "X",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920587,
                "x": "183",
                "y": "414",
                "row": "X",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920588,
                "x": "200",
                "y": "414",
                "row": "X",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920589,
                "x": "217",
                "y": "414",
                "row": "X",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920590,
                "x": "251",
                "y": "414",
                "row": "X",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920591,
                "x": "268",
                "y": "414",
                "row": "X",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920592,
                "x": "285",
                "y": "414",
                "row": "X",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920593,
                "x": "302",
                "y": "414",
                "row": "X",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920594,
                "x": "319",
                "y": "414",
                "row": "X",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920595,
                "x": "336",
                "y": "414",
                "row": "X",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920596,
                "x": "353",
                "y": "414",
                "row": "X",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920597,
                "x": "370",
                "y": "414",
                "row": "X",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920598,
                "x": "387",
                "y": "414",
                "row": "X",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920599,
                "x": "404",
                "y": "414",
                "row": "X",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920600,
                "x": "421",
                "y": "414",
                "row": "X",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920601,
                "x": "455",
                "y": "414",
                "row": "X",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920602,
                "x": "472",
                "y": "414",
                "row": "X",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920603,
                "x": "489",
                "y": "414",
                "row": "X",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920604,
                "x": "506",
                "y": "414",
                "row": "X",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920605,
                "x": "523",
                "y": "414",
                "row": "X",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920606,
                "x": "540",
                "y": "414",
                "row": "X",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920607,
                "x": "557",
                "y": "414",
                "row": "X",
                "col": "30",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920608,
                "x": "574",
                "y": "414",
                "row": "X",
                "col": "31",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920609,
                "x": "591",
                "y": "414",
                "row": "X",
                "col": "32",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920610,
                "x": "608",
                "y": "414",
                "row": "X",
                "col": "33",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920611,
                "x": "625",
                "y": "414",
                "row": "X",
                "col": "34",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920612,
                "x": "642",
                "y": "414",
                "row": "X",
                "col": "35",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920613,
                "x": "30",
                "y": "431",
                "row": "Y",
                "col": "1",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920614,
                "x": "47",
                "y": "431",
                "row": "Y",
                "col": "2",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920615,
                "x": "64",
                "y": "431",
                "row": "Y",
                "col": "3",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920616,
                "x": "81",
                "y": "431",
                "row": "Y",
                "col": "4",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920617,
                "x": "98",
                "y": "431",
                "row": "Y",
                "col": "5",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920618,
                "x": "115",
                "y": "431",
                "row": "Y",
                "col": "6",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920619,
                "x": "132",
                "y": "431",
                "row": "Y",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920620,
                "x": "149",
                "y": "431",
                "row": "Y",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920621,
                "x": "166",
                "y": "431",
                "row": "Y",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920622,
                "x": "183",
                "y": "431",
                "row": "Y",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920623,
                "x": "200",
                "y": "431",
                "row": "Y",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920624,
                "x": "217",
                "y": "431",
                "row": "Y",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920625,
                "x": "251",
                "y": "431",
                "row": "Y",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920626,
                "x": "268",
                "y": "431",
                "row": "Y",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920627,
                "x": "285",
                "y": "431",
                "row": "Y",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920628,
                "x": "302",
                "y": "431",
                "row": "Y",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920629,
                "x": "319",
                "y": "431",
                "row": "Y",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920630,
                "x": "336",
                "y": "431",
                "row": "Y",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920631,
                "x": "353",
                "y": "431",
                "row": "Y",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920632,
                "x": "370",
                "y": "431",
                "row": "Y",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920633,
                "x": "387",
                "y": "431",
                "row": "Y",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920634,
                "x": "404",
                "y": "431",
                "row": "Y",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920635,
                "x": "421",
                "y": "431",
                "row": "Y",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920636,
                "x": "455",
                "y": "431",
                "row": "Y",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920637,
                "x": "472",
                "y": "431",
                "row": "Y",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920638,
                "x": "489",
                "y": "431",
                "row": "Y",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920639,
                "x": "506",
                "y": "431",
                "row": "Y",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920640,
                "x": "523",
                "y": "431",
                "row": "Y",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920641,
                "x": "540",
                "y": "431",
                "row": "Y",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920642,
                "x": "557",
                "y": "431",
                "row": "Y",
                "col": "30",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920643,
                "x": "574",
                "y": "431",
                "row": "Y",
                "col": "31",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920644,
                "x": "591",
                "y": "431",
                "row": "Y",
                "col": "32",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920645,
                "x": "608",
                "y": "431",
                "row": "Y",
                "col": "33",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920646,
                "x": "625",
                "y": "431",
                "row": "Y",
                "col": "34",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920647,
                "x": "642",
                "y": "431",
                "row": "Y",
                "col": "35",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920648,
                "x": "47",
                "y": "108",
                "row": "E",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920649,
                "x": "64",
                "y": "108",
                "row": "E",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920650,
                "x": "81",
                "y": "108",
                "row": "E",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920651,
                "x": "98",
                "y": "108",
                "row": "E",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920652,
                "x": "115",
                "y": "108",
                "row": "E",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920653,
                "x": "132",
                "y": "108",
                "row": "E",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920654,
                "x": "149",
                "y": "108",
                "row": "E",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920655,
                "x": "166",
                "y": "108",
                "row": "E",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920656,
                "x": "183",
                "y": "108",
                "row": "E",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920657,
                "x": "200",
                "y": "108",
                "row": "E",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920658,
                "x": "217",
                "y": "108",
                "row": "E",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920659,
                "x": "251",
                "y": "108",
                "row": "E",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920660,
                "x": "268",
                "y": "108",
                "row": "E",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920661,
                "x": "285",
                "y": "108",
                "row": "E",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920662,
                "x": "302",
                "y": "108",
                "row": "E",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920663,
                "x": "319",
                "y": "108",
                "row": "E",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920664,
                "x": "336",
                "y": "108",
                "row": "E",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920665,
                "x": "353",
                "y": "108",
                "row": "E",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920666,
                "x": "370",
                "y": "108",
                "row": "E",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920667,
                "x": "387",
                "y": "108",
                "row": "E",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920668,
                "x": "404",
                "y": "108",
                "row": "E",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920669,
                "x": "421",
                "y": "108",
                "row": "E",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920670,
                "x": "455",
                "y": "108",
                "row": "E",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920671,
                "x": "472",
                "y": "108",
                "row": "E",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920672,
                "x": "489",
                "y": "108",
                "row": "E",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920673,
                "x": "506",
                "y": "108",
                "row": "E",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920674,
                "x": "523",
                "y": "108",
                "row": "E",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920675,
                "x": "540",
                "y": "108",
                "row": "E",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920676,
                "x": "557",
                "y": "108",
                "row": "E",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920677,
                "x": "574",
                "y": "108",
                "row": "E",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920678,
                "x": "591",
                "y": "108",
                "row": "E",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920679,
                "x": "608",
                "y": "108",
                "row": "E",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920680,
                "x": "625",
                "y": "108",
                "row": "E",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920681,
                "x": "642",
                "y": "108",
                "row": "E",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920682,
                "x": "47",
                "y": "125",
                "row": "F",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920683,
                "x": "64",
                "y": "125",
                "row": "F",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920684,
                "x": "81",
                "y": "125",
                "row": "F",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920685,
                "x": "98",
                "y": "125",
                "row": "F",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920686,
                "x": "115",
                "y": "125",
                "row": "F",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920687,
                "x": "132",
                "y": "125",
                "row": "F",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920688,
                "x": "149",
                "y": "125",
                "row": "F",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920689,
                "x": "166",
                "y": "125",
                "row": "F",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920690,
                "x": "183",
                "y": "125",
                "row": "F",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920691,
                "x": "200",
                "y": "125",
                "row": "F",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920692,
                "x": "217",
                "y": "125",
                "row": "F",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920693,
                "x": "251",
                "y": "125",
                "row": "F",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920694,
                "x": "268",
                "y": "125",
                "row": "F",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920695,
                "x": "285",
                "y": "125",
                "row": "F",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920696,
                "x": "302",
                "y": "125",
                "row": "F",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920697,
                "x": "319",
                "y": "125",
                "row": "F",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920698,
                "x": "336",
                "y": "125",
                "row": "F",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920699,
                "x": "353",
                "y": "125",
                "row": "F",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920700,
                "x": "370",
                "y": "125",
                "row": "F",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920701,
                "x": "387",
                "y": "125",
                "row": "F",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920702,
                "x": "404",
                "y": "125",
                "row": "F",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920703,
                "x": "421",
                "y": "125",
                "row": "F",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920704,
                "x": "455",
                "y": "125",
                "row": "F",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920705,
                "x": "472",
                "y": "125",
                "row": "F",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920706,
                "x": "489",
                "y": "125",
                "row": "F",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920707,
                "x": "506",
                "y": "125",
                "row": "F",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920708,
                "x": "523",
                "y": "125",
                "row": "F",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920709,
                "x": "540",
                "y": "125",
                "row": "F",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920710,
                "x": "557",
                "y": "125",
                "row": "F",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920711,
                "x": "574",
                "y": "125",
                "row": "F",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920712,
                "x": "591",
                "y": "125",
                "row": "F",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920713,
                "x": "608",
                "y": "125",
                "row": "F",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920714,
                "x": "625",
                "y": "125",
                "row": "F",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920715,
                "x": "642",
                "y": "125",
                "row": "F",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920716,
                "x": "47",
                "y": "40",
                "row": "A",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "SOLD"
            },
            {
                "id": 41920717,
                "x": "64",
                "y": "40",
                "row": "A",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "SOLD"
            },
            {
                "id": 41920718,
                "x": "81",
                "y": "40",
                "row": "A",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "SOLD"
            },
            {
                "id": 41920719,
                "x": "98",
                "y": "40",
                "row": "A",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "SOLD"
            },
            {
                "id": 41920720,
                "x": "115",
                "y": "40",
                "row": "A",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920721,
                "x": "132",
                "y": "40",
                "row": "A",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "SOLD"
            },
            {
                "id": 41920722,
                "x": "149",
                "y": "40",
                "row": "A",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "SOLD"
            },
            {
                "id": 41920723,
                "x": "166",
                "y": "40",
                "row": "A",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "SOLD"
            },
            {
                "id": 41920724,
                "x": "183",
                "y": "40",
                "row": "A",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920725,
                "x": "200",
                "y": "40",
                "row": "A",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920726,
                "x": "217",
                "y": "40",
                "row": "A",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920727,
                "x": "251",
                "y": "40",
                "row": "A",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920728,
                "x": "268",
                "y": "40",
                "row": "A",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920729,
                "x": "285",
                "y": "40",
                "row": "A",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920730,
                "x": "302",
                "y": "40",
                "row": "A",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920731,
                "x": "319",
                "y": "40",
                "row": "A",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920732,
                "x": "336",
                "y": "40",
                "row": "A",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920733,
                "x": "353",
                "y": "40",
                "row": "A",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920734,
                "x": "370",
                "y": "40",
                "row": "A",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920735,
                "x": "387",
                "y": "40",
                "row": "A",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920736,
                "x": "404",
                "y": "40",
                "row": "A",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920737,
                "x": "421",
                "y": "40",
                "row": "A",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920738,
                "x": "455",
                "y": "40",
                "row": "A",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920739,
                "x": "472",
                "y": "40",
                "row": "A",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920740,
                "x": "489",
                "y": "40",
                "row": "A",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920741,
                "x": "506",
                "y": "40",
                "row": "A",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920742,
                "x": "523",
                "y": "40",
                "row": "A",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920743,
                "x": "540",
                "y": "40",
                "row": "A",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920744,
                "x": "557",
                "y": "40",
                "row": "A",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920745,
                "x": "574",
                "y": "40",
                "row": "A",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920746,
                "x": "591",
                "y": "40",
                "row": "A",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920747,
                "x": "608",
                "y": "40",
                "row": "A",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920748,
                "x": "625",
                "y": "40",
                "row": "A",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920749,
                "x": "642",
                "y": "40",
                "row": "A",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920750,
                "x": "47",
                "y": "159",
                "row": "H",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920751,
                "x": "64",
                "y": "159",
                "row": "H",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920752,
                "x": "81",
                "y": "159",
                "row": "H",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920753,
                "x": "98",
                "y": "159",
                "row": "H",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920754,
                "x": "115",
                "y": "159",
                "row": "H",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920755,
                "x": "132",
                "y": "159",
                "row": "H",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920756,
                "x": "149",
                "y": "159",
                "row": "H",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920757,
                "x": "166",
                "y": "159",
                "row": "H",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920758,
                "x": "183",
                "y": "159",
                "row": "H",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920759,
                "x": "200",
                "y": "159",
                "row": "H",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920760,
                "x": "217",
                "y": "159",
                "row": "H",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920761,
                "x": "251",
                "y": "159",
                "row": "H",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920762,
                "x": "268",
                "y": "159",
                "row": "H",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920763,
                "x": "285",
                "y": "159",
                "row": "H",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920764,
                "x": "302",
                "y": "159",
                "row": "H",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920765,
                "x": "319",
                "y": "159",
                "row": "H",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920766,
                "x": "336",
                "y": "159",
                "row": "H",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920767,
                "x": "353",
                "y": "159",
                "row": "H",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920768,
                "x": "370",
                "y": "159",
                "row": "H",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920769,
                "x": "387",
                "y": "159",
                "row": "H",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920770,
                "x": "404",
                "y": "159",
                "row": "H",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920771,
                "x": "421",
                "y": "159",
                "row": "H",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920772,
                "x": "455",
                "y": "159",
                "row": "H",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920773,
                "x": "472",
                "y": "159",
                "row": "H",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920774,
                "x": "489",
                "y": "159",
                "row": "H",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920775,
                "x": "506",
                "y": "159",
                "row": "H",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920776,
                "x": "523",
                "y": "159",
                "row": "H",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920777,
                "x": "540",
                "y": "159",
                "row": "H",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920778,
                "x": "557",
                "y": "159",
                "row": "H",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920779,
                "x": "574",
                "y": "159",
                "row": "H",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920780,
                "x": "591",
                "y": "159",
                "row": "H",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920781,
                "x": "608",
                "y": "159",
                "row": "H",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920782,
                "x": "625",
                "y": "159",
                "row": "H",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920783,
                "x": "642",
                "y": "159",
                "row": "H",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920784,
                "x": "30",
                "y": "448",
                "row": "Z",
                "col": "1",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920785,
                "x": "47",
                "y": "448",
                "row": "Z",
                "col": "2",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920786,
                "x": "64",
                "y": "448",
                "row": "Z",
                "col": "3",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920787,
                "x": "81",
                "y": "448",
                "row": "Z",
                "col": "4",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920788,
                "x": "98",
                "y": "448",
                "row": "Z",
                "col": "5",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920789,
                "x": "115",
                "y": "448",
                "row": "Z",
                "col": "6",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920790,
                "x": "132",
                "y": "448",
                "row": "Z",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920791,
                "x": "149",
                "y": "448",
                "row": "Z",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920792,
                "x": "166",
                "y": "448",
                "row": "Z",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920793,
                "x": "183",
                "y": "448",
                "row": "Z",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920794,
                "x": "200",
                "y": "448",
                "row": "Z",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920795,
                "x": "217",
                "y": "448",
                "row": "Z",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920796,
                "x": "251",
                "y": "448",
                "row": "Z",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920797,
                "x": "268",
                "y": "448",
                "row": "Z",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920798,
                "x": "285",
                "y": "448",
                "row": "Z",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920799,
                "x": "302",
                "y": "448",
                "row": "Z",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920800,
                "x": "319",
                "y": "448",
                "row": "Z",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920801,
                "x": "336",
                "y": "448",
                "row": "Z",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920802,
                "x": "353",
                "y": "448",
                "row": "Z",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920803,
                "x": "370",
                "y": "448",
                "row": "Z",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920804,
                "x": "387",
                "y": "448",
                "row": "Z",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920805,
                "x": "404",
                "y": "448",
                "row": "Z",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920806,
                "x": "421",
                "y": "448",
                "row": "Z",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920807,
                "x": "455",
                "y": "448",
                "row": "Z",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920808,
                "x": "472",
                "y": "448",
                "row": "Z",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920809,
                "x": "489",
                "y": "448",
                "row": "Z",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920810,
                "x": "506",
                "y": "448",
                "row": "Z",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920811,
                "x": "523",
                "y": "448",
                "row": "Z",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920812,
                "x": "540",
                "y": "448",
                "row": "Z",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920813,
                "x": "557",
                "y": "448",
                "row": "Z",
                "col": "30",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920814,
                "x": "574",
                "y": "448",
                "row": "Z",
                "col": "31",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920815,
                "x": "591",
                "y": "448",
                "row": "Z",
                "col": "32",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920816,
                "x": "608",
                "y": "448",
                "row": "Z",
                "col": "33",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920817,
                "x": "625",
                "y": "448",
                "row": "Z",
                "col": "34",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920818,
                "x": "642",
                "y": "448",
                "row": "Z",
                "col": "35",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920819,
                "x": "47",
                "y": "74",
                "row": "C",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920820,
                "x": "64",
                "y": "74",
                "row": "C",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920821,
                "x": "81",
                "y": "74",
                "row": "C",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920822,
                "x": "98",
                "y": "74",
                "row": "C",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920823,
                "x": "115",
                "y": "74",
                "row": "C",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920824,
                "x": "132",
                "y": "74",
                "row": "C",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920825,
                "x": "149",
                "y": "74",
                "row": "C",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920826,
                "x": "166",
                "y": "74",
                "row": "C",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920827,
                "x": "183",
                "y": "74",
                "row": "C",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920828,
                "x": "200",
                "y": "74",
                "row": "C",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920829,
                "x": "217",
                "y": "74",
                "row": "C",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920830,
                "x": "251",
                "y": "74",
                "row": "C",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920831,
                "x": "268",
                "y": "74",
                "row": "C",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920832,
                "x": "285",
                "y": "74",
                "row": "C",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920833,
                "x": "302",
                "y": "74",
                "row": "C",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920834,
                "x": "319",
                "y": "74",
                "row": "C",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920835,
                "x": "336",
                "y": "74",
                "row": "C",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920836,
                "x": "353",
                "y": "74",
                "row": "C",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920837,
                "x": "370",
                "y": "74",
                "row": "C",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920838,
                "x": "387",
                "y": "74",
                "row": "C",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920839,
                "x": "404",
                "y": "74",
                "row": "C",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920840,
                "x": "421",
                "y": "74",
                "row": "C",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920841,
                "x": "455",
                "y": "74",
                "row": "C",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920842,
                "x": "472",
                "y": "74",
                "row": "C",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920843,
                "x": "489",
                "y": "74",
                "row": "C",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920844,
                "x": "506",
                "y": "74",
                "row": "C",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920845,
                "x": "523",
                "y": "74",
                "row": "C",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920846,
                "x": "540",
                "y": "74",
                "row": "C",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920847,
                "x": "557",
                "y": "74",
                "row": "C",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920848,
                "x": "574",
                "y": "74",
                "row": "C",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920849,
                "x": "591",
                "y": "74",
                "row": "C",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920850,
                "x": "608",
                "y": "74",
                "row": "C",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920851,
                "x": "625",
                "y": "74",
                "row": "C",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920852,
                "x": "642",
                "y": "74",
                "row": "C",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920853,
                "x": "132",
                "y": "261",
                "row": "N",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920854,
                "x": "149",
                "y": "261",
                "row": "N",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920855,
                "x": "166",
                "y": "261",
                "row": "N",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920856,
                "x": "183",
                "y": "261",
                "row": "N",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920857,
                "x": "200",
                "y": "261",
                "row": "N",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920858,
                "x": "217",
                "y": "261",
                "row": "N",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920859,
                "x": "251",
                "y": "261",
                "row": "N",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920860,
                "x": "268",
                "y": "261",
                "row": "N",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920861,
                "x": "285",
                "y": "261",
                "row": "N",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920862,
                "x": "302",
                "y": "261",
                "row": "N",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920863,
                "x": "319",
                "y": "261",
                "row": "N",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920864,
                "x": "336",
                "y": "261",
                "row": "N",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920865,
                "x": "353",
                "y": "261",
                "row": "N",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920866,
                "x": "370",
                "y": "261",
                "row": "N",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920867,
                "x": "387",
                "y": "261",
                "row": "N",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920868,
                "x": "404",
                "y": "261",
                "row": "N",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920869,
                "x": "421",
                "y": "261",
                "row": "N",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920870,
                "x": "455",
                "y": "261",
                "row": "N",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920871,
                "x": "472",
                "y": "261",
                "row": "N",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920872,
                "x": "489",
                "y": "261",
                "row": "N",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920873,
                "x": "506",
                "y": "261",
                "row": "N",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920874,
                "x": "523",
                "y": "261",
                "row": "N",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920875,
                "x": "540",
                "y": "261",
                "row": "N",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920876,
                "x": "30",
                "y": "380",
                "row": "V",
                "col": "1",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920877,
                "x": "47",
                "y": "380",
                "row": "V",
                "col": "2",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920878,
                "x": "64",
                "y": "380",
                "row": "V",
                "col": "3",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920879,
                "x": "81",
                "y": "380",
                "row": "V",
                "col": "4",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920880,
                "x": "98",
                "y": "380",
                "row": "V",
                "col": "5",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920881,
                "x": "115",
                "y": "380",
                "row": "V",
                "col": "6",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920882,
                "x": "132",
                "y": "380",
                "row": "V",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920883,
                "x": "149",
                "y": "380",
                "row": "V",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920884,
                "x": "166",
                "y": "380",
                "row": "V",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920885,
                "x": "183",
                "y": "380",
                "row": "V",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920886,
                "x": "200",
                "y": "380",
                "row": "V",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920887,
                "x": "217",
                "y": "380",
                "row": "V",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920888,
                "x": "251",
                "y": "380",
                "row": "V",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920889,
                "x": "268",
                "y": "380",
                "row": "V",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920890,
                "x": "285",
                "y": "380",
                "row": "V",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920891,
                "x": "302",
                "y": "380",
                "row": "V",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920892,
                "x": "319",
                "y": "380",
                "row": "V",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920893,
                "x": "336",
                "y": "380",
                "row": "V",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920894,
                "x": "353",
                "y": "380",
                "row": "V",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920895,
                "x": "370",
                "y": "380",
                "row": "V",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920896,
                "x": "387",
                "y": "380",
                "row": "V",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920897,
                "x": "404",
                "y": "380",
                "row": "V",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920898,
                "x": "421",
                "y": "380",
                "row": "V",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920899,
                "x": "455",
                "y": "380",
                "row": "V",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920900,
                "x": "472",
                "y": "380",
                "row": "V",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920901,
                "x": "489",
                "y": "380",
                "row": "V",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920902,
                "x": "506",
                "y": "380",
                "row": "V",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920903,
                "x": "523",
                "y": "380",
                "row": "V",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920904,
                "x": "540",
                "y": "380",
                "row": "V",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920905,
                "x": "557",
                "y": "380",
                "row": "V",
                "col": "30",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920906,
                "x": "574",
                "y": "380",
                "row": "V",
                "col": "31",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920907,
                "x": "591",
                "y": "380",
                "row": "V",
                "col": "32",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920908,
                "x": "608",
                "y": "380",
                "row": "V",
                "col": "33",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920909,
                "x": "625",
                "y": "380",
                "row": "V",
                "col": "34",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920910,
                "x": "642",
                "y": "380",
                "row": "V",
                "col": "35",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920911,
                "x": "132",
                "y": "329",
                "row": "S",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920912,
                "x": "149",
                "y": "329",
                "row": "S",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920913,
                "x": "166",
                "y": "329",
                "row": "S",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920914,
                "x": "183",
                "y": "329",
                "row": "S",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920915,
                "x": "200",
                "y": "329",
                "row": "S",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920916,
                "x": "217",
                "y": "329",
                "row": "S",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920917,
                "x": "251",
                "y": "329",
                "row": "S",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920918,
                "x": "268",
                "y": "329",
                "row": "S",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920919,
                "x": "285",
                "y": "329",
                "row": "S",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920920,
                "x": "302",
                "y": "329",
                "row": "S",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920921,
                "x": "319",
                "y": "329",
                "row": "S",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920922,
                "x": "336",
                "y": "329",
                "row": "S",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920923,
                "x": "353",
                "y": "329",
                "row": "S",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920924,
                "x": "370",
                "y": "329",
                "row": "S",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920925,
                "x": "387",
                "y": "329",
                "row": "S",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920926,
                "x": "404",
                "y": "329",
                "row": "S",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920927,
                "x": "421",
                "y": "329",
                "row": "S",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920928,
                "x": "455",
                "y": "329",
                "row": "S",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920929,
                "x": "472",
                "y": "329",
                "row": "S",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920930,
                "x": "489",
                "y": "329",
                "row": "S",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920931,
                "x": "506",
                "y": "329",
                "row": "S",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920932,
                "x": "523",
                "y": "329",
                "row": "S",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920933,
                "x": "540",
                "y": "329",
                "row": "S",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920934,
                "x": "47",
                "y": "91",
                "row": "D",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920935,
                "x": "64",
                "y": "91",
                "row": "D",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920936,
                "x": "81",
                "y": "91",
                "row": "D",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920937,
                "x": "98",
                "y": "91",
                "row": "D",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920938,
                "x": "115",
                "y": "91",
                "row": "D",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920939,
                "x": "132",
                "y": "91",
                "row": "D",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920940,
                "x": "149",
                "y": "91",
                "row": "D",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920941,
                "x": "166",
                "y": "91",
                "row": "D",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920942,
                "x": "183",
                "y": "91",
                "row": "D",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920943,
                "x": "200",
                "y": "91",
                "row": "D",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920944,
                "x": "217",
                "y": "91",
                "row": "D",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920945,
                "x": "251",
                "y": "91",
                "row": "D",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920946,
                "x": "268",
                "y": "91",
                "row": "D",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920947,
                "x": "285",
                "y": "91",
                "row": "D",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920948,
                "x": "302",
                "y": "91",
                "row": "D",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920949,
                "x": "319",
                "y": "91",
                "row": "D",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920950,
                "x": "336",
                "y": "91",
                "row": "D",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920951,
                "x": "353",
                "y": "91",
                "row": "D",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920952,
                "x": "370",
                "y": "91",
                "row": "D",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920953,
                "x": "387",
                "y": "91",
                "row": "D",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920954,
                "x": "404",
                "y": "91",
                "row": "D",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920955,
                "x": "421",
                "y": "91",
                "row": "D",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920956,
                "x": "455",
                "y": "91",
                "row": "D",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920957,
                "x": "472",
                "y": "91",
                "row": "D",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920958,
                "x": "489",
                "y": "91",
                "row": "D",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920959,
                "x": "506",
                "y": "91",
                "row": "D",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920960,
                "x": "523",
                "y": "91",
                "row": "D",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920961,
                "x": "540",
                "y": "91",
                "row": "D",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920962,
                "x": "557",
                "y": "91",
                "row": "D",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920963,
                "x": "574",
                "y": "91",
                "row": "D",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920964,
                "x": "591",
                "y": "91",
                "row": "D",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920965,
                "x": "608",
                "y": "91",
                "row": "D",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920966,
                "x": "625",
                "y": "91",
                "row": "D",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920967,
                "x": "642",
                "y": "91",
                "row": "D",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920968,
                "x": "132",
                "y": "278",
                "row": "P",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920969,
                "x": "149",
                "y": "278",
                "row": "P",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920970,
                "x": "166",
                "y": "278",
                "row": "P",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920971,
                "x": "183",
                "y": "278",
                "row": "P",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920972,
                "x": "200",
                "y": "278",
                "row": "P",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920973,
                "x": "217",
                "y": "278",
                "row": "P",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920974,
                "x": "251",
                "y": "278",
                "row": "P",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920975,
                "x": "268",
                "y": "278",
                "row": "P",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920976,
                "x": "285",
                "y": "278",
                "row": "P",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920977,
                "x": "302",
                "y": "278",
                "row": "P",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920978,
                "x": "319",
                "y": "278",
                "row": "P",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920979,
                "x": "336",
                "y": "278",
                "row": "P",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920980,
                "x": "353",
                "y": "278",
                "row": "P",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920981,
                "x": "370",
                "y": "278",
                "row": "P",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920982,
                "x": "387",
                "y": "278",
                "row": "P",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920983,
                "x": "404",
                "y": "278",
                "row": "P",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920984,
                "x": "421",
                "y": "278",
                "row": "P",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920985,
                "x": "455",
                "y": "278",
                "row": "P",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920986,
                "x": "472",
                "y": "278",
                "row": "P",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920987,
                "x": "489",
                "y": "278",
                "row": "P",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920988,
                "x": "506",
                "y": "278",
                "row": "P",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920989,
                "x": "523",
                "y": "278",
                "row": "P",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920990,
                "x": "540",
                "y": "278",
                "row": "P",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920991,
                "x": "47",
                "y": "193",
                "row": "K",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920992,
                "x": "64",
                "y": "193",
                "row": "K",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920993,
                "x": "81",
                "y": "193",
                "row": "K",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920994,
                "x": "98",
                "y": "193",
                "row": "K",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920995,
                "x": "115",
                "y": "193",
                "row": "K",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920996,
                "x": "132",
                "y": "193",
                "row": "K",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920997,
                "x": "149",
                "y": "193",
                "row": "K",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920998,
                "x": "166",
                "y": "193",
                "row": "K",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41920999,
                "x": "183",
                "y": "193",
                "row": "K",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921000,
                "x": "200",
                "y": "193",
                "row": "K",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921001,
                "x": "217",
                "y": "193",
                "row": "K",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921002,
                "x": "251",
                "y": "193",
                "row": "K",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921003,
                "x": "268",
                "y": "193",
                "row": "K",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921004,
                "x": "285",
                "y": "193",
                "row": "K",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921005,
                "x": "302",
                "y": "193",
                "row": "K",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921006,
                "x": "319",
                "y": "193",
                "row": "K",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921007,
                "x": "336",
                "y": "193",
                "row": "K",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921008,
                "x": "353",
                "y": "193",
                "row": "K",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921009,
                "x": "370",
                "y": "193",
                "row": "K",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921010,
                "x": "387",
                "y": "193",
                "row": "K",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921011,
                "x": "404",
                "y": "193",
                "row": "K",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921012,
                "x": "421",
                "y": "193",
                "row": "K",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921013,
                "x": "455",
                "y": "193",
                "row": "K",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921014,
                "x": "472",
                "y": "193",
                "row": "K",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921015,
                "x": "489",
                "y": "193",
                "row": "K",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921016,
                "x": "506",
                "y": "193",
                "row": "K",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921017,
                "x": "523",
                "y": "193",
                "row": "K",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921018,
                "x": "540",
                "y": "193",
                "row": "K",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921019,
                "x": "557",
                "y": "193",
                "row": "K",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921020,
                "x": "574",
                "y": "193",
                "row": "K",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921021,
                "x": "591",
                "y": "193",
                "row": "K",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921022,
                "x": "608",
                "y": "193",
                "row": "K",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921023,
                "x": "625",
                "y": "193",
                "row": "K",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921024,
                "x": "642",
                "y": "193",
                "row": "K",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921025,
                "x": "47",
                "y": "57",
                "row": "B",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921026,
                "x": "64",
                "y": "57",
                "row": "B",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921027,
                "x": "81",
                "y": "57",
                "row": "B",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921028,
                "x": "98",
                "y": "57",
                "row": "B",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921029,
                "x": "115",
                "y": "57",
                "row": "B",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921030,
                "x": "132",
                "y": "57",
                "row": "B",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921031,
                "x": "149",
                "y": "57",
                "row": "B",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921032,
                "x": "166",
                "y": "57",
                "row": "B",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921033,
                "x": "183",
                "y": "57",
                "row": "B",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921034,
                "x": "200",
                "y": "57",
                "row": "B",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921035,
                "x": "217",
                "y": "57",
                "row": "B",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921036,
                "x": "251",
                "y": "57",
                "row": "B",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921037,
                "x": "268",
                "y": "57",
                "row": "B",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921038,
                "x": "285",
                "y": "57",
                "row": "B",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921039,
                "x": "302",
                "y": "57",
                "row": "B",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921040,
                "x": "319",
                "y": "57",
                "row": "B",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921041,
                "x": "336",
                "y": "57",
                "row": "B",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921042,
                "x": "353",
                "y": "57",
                "row": "B",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921043,
                "x": "370",
                "y": "57",
                "row": "B",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921044,
                "x": "387",
                "y": "57",
                "row": "B",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921045,
                "x": "404",
                "y": "57",
                "row": "B",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921046,
                "x": "421",
                "y": "57",
                "row": "B",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921047,
                "x": "455",
                "y": "57",
                "row": "B",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921048,
                "x": "472",
                "y": "57",
                "row": "B",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 197,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921049,
                "x": "489",
                "y": "57",
                "row": "B",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921050,
                "x": "506",
                "y": "57",
                "row": "B",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921051,
                "x": "523",
                "y": "57",
                "row": "B",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921052,
                "x": "540",
                "y": "57",
                "row": "B",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921053,
                "x": "557",
                "y": "57",
                "row": "B",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921054,
                "x": "574",
                "y": "57",
                "row": "B",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921055,
                "x": "591",
                "y": "57",
                "row": "B",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921056,
                "x": "608",
                "y": "57",
                "row": "B",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921057,
                "x": "625",
                "y": "57",
                "row": "B",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921058,
                "x": "642",
                "y": "57",
                "row": "B",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921059,
                "x": "47",
                "y": "210",
                "row": "L",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921060,
                "x": "64",
                "y": "210",
                "row": "L",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921061,
                "x": "81",
                "y": "210",
                "row": "L",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921062,
                "x": "98",
                "y": "210",
                "row": "L",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921063,
                "x": "115",
                "y": "210",
                "row": "L",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921064,
                "x": "132",
                "y": "210",
                "row": "L",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921065,
                "x": "149",
                "y": "210",
                "row": "L",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921066,
                "x": "166",
                "y": "210",
                "row": "L",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921067,
                "x": "183",
                "y": "210",
                "row": "L",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921068,
                "x": "200",
                "y": "210",
                "row": "L",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921069,
                "x": "217",
                "y": "210",
                "row": "L",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921070,
                "x": "251",
                "y": "210",
                "row": "L",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921071,
                "x": "268",
                "y": "210",
                "row": "L",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921072,
                "x": "285",
                "y": "210",
                "row": "L",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921073,
                "x": "302",
                "y": "210",
                "row": "L",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921074,
                "x": "319",
                "y": "210",
                "row": "L",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921075,
                "x": "336",
                "y": "210",
                "row": "L",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921076,
                "x": "353",
                "y": "210",
                "row": "L",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921077,
                "x": "370",
                "y": "210",
                "row": "L",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921078,
                "x": "387",
                "y": "210",
                "row": "L",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921079,
                "x": "404",
                "y": "210",
                "row": "L",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921080,
                "x": "421",
                "y": "210",
                "row": "L",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921081,
                "x": "455",
                "y": "210",
                "row": "L",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921082,
                "x": "472",
                "y": "210",
                "row": "L",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921083,
                "x": "489",
                "y": "210",
                "row": "L",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921084,
                "x": "506",
                "y": "210",
                "row": "L",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921085,
                "x": "523",
                "y": "210",
                "row": "L",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921086,
                "x": "540",
                "y": "210",
                "row": "L",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921087,
                "x": "557",
                "y": "210",
                "row": "L",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921088,
                "x": "574",
                "y": "210",
                "row": "L",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921089,
                "x": "591",
                "y": "210",
                "row": "L",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921090,
                "x": "608",
                "y": "210",
                "row": "L",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921091,
                "x": "625",
                "y": "210",
                "row": "L",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921092,
                "x": "642",
                "y": "210",
                "row": "L",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921093,
                "x": "47",
                "y": "142",
                "row": "G",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921094,
                "x": "64",
                "y": "142",
                "row": "G",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921095,
                "x": "81",
                "y": "142",
                "row": "G",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921096,
                "x": "98",
                "y": "142",
                "row": "G",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921097,
                "x": "115",
                "y": "142",
                "row": "G",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921098,
                "x": "132",
                "y": "142",
                "row": "G",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921099,
                "x": "149",
                "y": "142",
                "row": "G",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921100,
                "x": "166",
                "y": "142",
                "row": "G",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921101,
                "x": "183",
                "y": "142",
                "row": "G",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921102,
                "x": "200",
                "y": "142",
                "row": "G",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921103,
                "x": "217",
                "y": "142",
                "row": "G",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921104,
                "x": "251",
                "y": "142",
                "row": "G",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921105,
                "x": "268",
                "y": "142",
                "row": "G",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921106,
                "x": "285",
                "y": "142",
                "row": "G",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921107,
                "x": "302",
                "y": "142",
                "row": "G",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921108,
                "x": "319",
                "y": "142",
                "row": "G",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921109,
                "x": "336",
                "y": "142",
                "row": "G",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921110,
                "x": "353",
                "y": "142",
                "row": "G",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921111,
                "x": "370",
                "y": "142",
                "row": "G",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921112,
                "x": "387",
                "y": "142",
                "row": "G",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921113,
                "x": "404",
                "y": "142",
                "row": "G",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921114,
                "x": "421",
                "y": "142",
                "row": "G",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921115,
                "x": "455",
                "y": "142",
                "row": "G",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921116,
                "x": "472",
                "y": "142",
                "row": "G",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921117,
                "x": "489",
                "y": "142",
                "row": "G",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921118,
                "x": "506",
                "y": "142",
                "row": "G",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921119,
                "x": "523",
                "y": "142",
                "row": "G",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921120,
                "x": "540",
                "y": "142",
                "row": "G",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921121,
                "x": "557",
                "y": "142",
                "row": "G",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921122,
                "x": "574",
                "y": "142",
                "row": "G",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921123,
                "x": "591",
                "y": "142",
                "row": "G",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921124,
                "x": "608",
                "y": "142",
                "row": "G",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921125,
                "x": "625",
                "y": "142",
                "row": "G",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921126,
                "x": "642",
                "y": "142",
                "row": "G",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921127,
                "x": "47",
                "y": "176",
                "row": "J",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921128,
                "x": "64",
                "y": "176",
                "row": "J",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921129,
                "x": "81",
                "y": "176",
                "row": "J",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921130,
                "x": "98",
                "y": "176",
                "row": "J",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921131,
                "x": "115",
                "y": "176",
                "row": "J",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921132,
                "x": "132",
                "y": "176",
                "row": "J",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921133,
                "x": "149",
                "y": "176",
                "row": "J",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921134,
                "x": "166",
                "y": "176",
                "row": "J",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921135,
                "x": "183",
                "y": "176",
                "row": "J",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921136,
                "x": "200",
                "y": "176",
                "row": "J",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921137,
                "x": "217",
                "y": "176",
                "row": "J",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921138,
                "x": "251",
                "y": "176",
                "row": "J",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921139,
                "x": "268",
                "y": "176",
                "row": "J",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921140,
                "x": "285",
                "y": "176",
                "row": "J",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921141,
                "x": "302",
                "y": "176",
                "row": "J",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921142,
                "x": "319",
                "y": "176",
                "row": "J",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921143,
                "x": "336",
                "y": "176",
                "row": "J",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921144,
                "x": "353",
                "y": "176",
                "row": "J",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921145,
                "x": "370",
                "y": "176",
                "row": "J",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921146,
                "x": "387",
                "y": "176",
                "row": "J",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921147,
                "x": "404",
                "y": "176",
                "row": "J",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921148,
                "x": "421",
                "y": "176",
                "row": "J",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921149,
                "x": "455",
                "y": "176",
                "row": "J",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921150,
                "x": "472",
                "y": "176",
                "row": "J",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921151,
                "x": "489",
                "y": "176",
                "row": "J",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921152,
                "x": "506",
                "y": "176",
                "row": "J",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921153,
                "x": "523",
                "y": "176",
                "row": "J",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921154,
                "x": "540",
                "y": "176",
                "row": "J",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921155,
                "x": "557",
                "y": "176",
                "row": "J",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921156,
                "x": "574",
                "y": "176",
                "row": "J",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921157,
                "x": "591",
                "y": "176",
                "row": "J",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921158,
                "x": "608",
                "y": "176",
                "row": "J",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921159,
                "x": "625",
                "y": "176",
                "row": "J",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921160,
                "x": "642",
                "y": "176",
                "row": "J",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921169,
                "x": "183",
                "y": "227",
                "row": "M",
                "col": "10",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921170,
                "x": "200",
                "y": "227",
                "row": "M",
                "col": "11",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921171,
                "x": "217",
                "y": "227",
                "row": "M",
                "col": "12",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921172,
                "x": "251",
                "y": "227",
                "row": "M",
                "col": "13",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921173,
                "x": "268",
                "y": "227",
                "row": "M",
                "col": "14",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921174,
                "x": "285",
                "y": "227",
                "row": "M",
                "col": "15",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921175,
                "x": "302",
                "y": "227",
                "row": "M",
                "col": "16",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921176,
                "x": "319",
                "y": "227",
                "row": "M",
                "col": "17",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921177,
                "x": "336",
                "y": "227",
                "row": "M",
                "col": "18",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921178,
                "x": "353",
                "y": "227",
                "row": "M",
                "col": "19",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921179,
                "x": "370",
                "y": "227",
                "row": "M",
                "col": "20",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921180,
                "x": "387",
                "y": "227",
                "row": "M",
                "col": "21",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921181,
                "x": "404",
                "y": "227",
                "row": "M",
                "col": "22",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921182,
                "x": "421",
                "y": "227",
                "row": "M",
                "col": "23",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921183,
                "x": "455",
                "y": "227",
                "row": "M",
                "col": "24",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921184,
                "x": "472",
                "y": "227",
                "row": "M",
                "col": "25",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921185,
                "x": "489",
                "y": "227",
                "row": "M",
                "col": "26",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921186,
                "x": "506",
                "y": "227",
                "row": "M",
                "col": "27",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921187,
                "x": "523",
                "y": "227",
                "row": "M",
                "col": "28",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921188,
                "x": "540",
                "y": "227",
                "row": "M",
                "col": "29",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921189,
                "x": "557",
                "y": "227",
                "row": "M",
                "col": "30",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921190,
                "x": "574",
                "y": "227",
                "row": "M",
                "col": "31",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921191,
                "x": "591",
                "y": "227",
                "row": "M",
                "col": "32",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921192,
                "x": "608",
                "y": "227",
                "row": "M",
                "col": "33",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921193,
                "x": "625",
                "y": "227",
                "row": "M",
                "col": "34",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921194,
                "x": "642",
                "y": "227",
                "row": "M",
                "col": "35",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921161,
                "x": "47",
                "y": "227",
                "row": "M",
                "col": "2",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921162,
                "x": "64",
                "y": "227",
                "row": "M",
                "col": "3",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921163,
                "x": "81",
                "y": "227",
                "row": "M",
                "col": "4",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921164,
                "x": "98",
                "y": "227",
                "row": "M",
                "col": "5",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921165,
                "x": "115",
                "y": "227",
                "row": "M",
                "col": "6",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921166,
                "x": "132",
                "y": "227",
                "row": "M",
                "col": "7",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921167,
                "x": "149",
                "y": "227",
                "row": "M",
                "col": "8",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921168,
                "x": "166",
                "y": "227",
                "row": "M",
                "col": "9",
                "gate": "GROUND",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921195,
                "x": "30",
                "y": "363",
                "row": "U",
                "col": "1",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921196,
                "x": "47",
                "y": "363",
                "row": "U",
                "col": "2",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921197,
                "x": "64",
                "y": "363",
                "row": "U",
                "col": "3",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921198,
                "x": "81",
                "y": "363",
                "row": "U",
                "col": "4",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921199,
                "x": "98",
                "y": "363",
                "row": "U",
                "col": "5",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921200,
                "x": "115",
                "y": "363",
                "row": "U",
                "col": "6",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921201,
                "x": "132",
                "y": "363",
                "row": "U",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921202,
                "x": "149",
                "y": "363",
                "row": "U",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921203,
                "x": "166",
                "y": "363",
                "row": "U",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921204,
                "x": "183",
                "y": "363",
                "row": "U",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921205,
                "x": "200",
                "y": "363",
                "row": "U",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921206,
                "x": "217",
                "y": "363",
                "row": "U",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921207,
                "x": "251",
                "y": "363",
                "row": "U",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921208,
                "x": "268",
                "y": "363",
                "row": "U",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921209,
                "x": "285",
                "y": "363",
                "row": "U",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921210,
                "x": "302",
                "y": "363",
                "row": "U",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921211,
                "x": "319",
                "y": "363",
                "row": "U",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921212,
                "x": "336",
                "y": "363",
                "row": "U",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921213,
                "x": "353",
                "y": "363",
                "row": "U",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921214,
                "x": "370",
                "y": "363",
                "row": "U",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921215,
                "x": "387",
                "y": "363",
                "row": "U",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921216,
                "x": "404",
                "y": "363",
                "row": "U",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921217,
                "x": "421",
                "y": "363",
                "row": "U",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921218,
                "x": "455",
                "y": "363",
                "row": "U",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921219,
                "x": "472",
                "y": "363",
                "row": "U",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921220,
                "x": "489",
                "y": "363",
                "row": "U",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921221,
                "x": "506",
                "y": "363",
                "row": "U",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921222,
                "x": "523",
                "y": "363",
                "row": "U",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921223,
                "x": "540",
                "y": "363",
                "row": "U",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921224,
                "x": "557",
                "y": "363",
                "row": "U",
                "col": "30",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921225,
                "x": "574",
                "y": "363",
                "row": "U",
                "col": "31",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921226,
                "x": "591",
                "y": "363",
                "row": "U",
                "col": "32",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921227,
                "x": "608",
                "y": "363",
                "row": "U",
                "col": "33",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921228,
                "x": "625",
                "y": "363",
                "row": "U",
                "col": "34",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921229,
                "x": "642",
                "y": "363",
                "row": "U",
                "col": "35",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921230,
                "x": "30",
                "y": "397",
                "row": "W",
                "col": "1",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921231,
                "x": "47",
                "y": "397",
                "row": "W",
                "col": "2",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921232,
                "x": "64",
                "y": "397",
                "row": "W",
                "col": "3",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921233,
                "x": "81",
                "y": "397",
                "row": "W",
                "col": "4",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921234,
                "x": "98",
                "y": "397",
                "row": "W",
                "col": "5",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921235,
                "x": "115",
                "y": "397",
                "row": "W",
                "col": "6",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921236,
                "x": "132",
                "y": "397",
                "row": "W",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921237,
                "x": "149",
                "y": "397",
                "row": "W",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921238,
                "x": "166",
                "y": "397",
                "row": "W",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921239,
                "x": "183",
                "y": "397",
                "row": "W",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921240,
                "x": "200",
                "y": "397",
                "row": "W",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921241,
                "x": "217",
                "y": "397",
                "row": "W",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921242,
                "x": "251",
                "y": "397",
                "row": "W",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921243,
                "x": "268",
                "y": "397",
                "row": "W",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921244,
                "x": "285",
                "y": "397",
                "row": "W",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921245,
                "x": "302",
                "y": "397",
                "row": "W",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921246,
                "x": "319",
                "y": "397",
                "row": "W",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921247,
                "x": "336",
                "y": "397",
                "row": "W",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921248,
                "x": "353",
                "y": "397",
                "row": "W",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921249,
                "x": "370",
                "y": "397",
                "row": "W",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921250,
                "x": "387",
                "y": "397",
                "row": "W",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921251,
                "x": "404",
                "y": "397",
                "row": "W",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921252,
                "x": "421",
                "y": "397",
                "row": "W",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921253,
                "x": "455",
                "y": "397",
                "row": "W",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921254,
                "x": "472",
                "y": "397",
                "row": "W",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921255,
                "x": "489",
                "y": "397",
                "row": "W",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921256,
                "x": "506",
                "y": "397",
                "row": "W",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921257,
                "x": "523",
                "y": "397",
                "row": "W",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921258,
                "x": "540",
                "y": "397",
                "row": "W",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921259,
                "x": "557",
                "y": "397",
                "row": "W",
                "col": "30",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921260,
                "x": "574",
                "y": "397",
                "row": "W",
                "col": "31",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921261,
                "x": "591",
                "y": "397",
                "row": "W",
                "col": "32",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921262,
                "x": "608",
                "y": "397",
                "row": "W",
                "col": "33",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921263,
                "x": "625",
                "y": "397",
                "row": "W",
                "col": "34",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921264,
                "x": "642",
                "y": "397",
                "row": "W",
                "col": "35",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921265,
                "x": "30",
                "y": "346",
                "row": "T",
                "col": "1",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921266,
                "x": "47",
                "y": "346",
                "row": "T",
                "col": "2",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921267,
                "x": "64",
                "y": "346",
                "row": "T",
                "col": "3",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921268,
                "x": "81",
                "y": "346",
                "row": "T",
                "col": "4",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921269,
                "x": "98",
                "y": "346",
                "row": "T",
                "col": "5",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921270,
                "x": "115",
                "y": "346",
                "row": "T",
                "col": "6",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921271,
                "x": "132",
                "y": "346",
                "row": "T",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921272,
                "x": "149",
                "y": "346",
                "row": "T",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921273,
                "x": "166",
                "y": "346",
                "row": "T",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921274,
                "x": "183",
                "y": "346",
                "row": "T",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921275,
                "x": "200",
                "y": "346",
                "row": "T",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921276,
                "x": "217",
                "y": "346",
                "row": "T",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921277,
                "x": "251",
                "y": "346",
                "row": "T",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921278,
                "x": "268",
                "y": "346",
                "row": "T",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921279,
                "x": "285",
                "y": "346",
                "row": "T",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921280,
                "x": "302",
                "y": "346",
                "row": "T",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921281,
                "x": "319",
                "y": "346",
                "row": "T",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921282,
                "x": "336",
                "y": "346",
                "row": "T",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921283,
                "x": "353",
                "y": "346",
                "row": "T",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921284,
                "x": "370",
                "y": "346",
                "row": "T",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921285,
                "x": "387",
                "y": "346",
                "row": "T",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921286,
                "x": "404",
                "y": "346",
                "row": "T",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921287,
                "x": "421",
                "y": "346",
                "row": "T",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921288,
                "x": "455",
                "y": "346",
                "row": "T",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921289,
                "x": "472",
                "y": "346",
                "row": "T",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921290,
                "x": "489",
                "y": "346",
                "row": "T",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921291,
                "x": "506",
                "y": "346",
                "row": "T",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921292,
                "x": "523",
                "y": "346",
                "row": "T",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921293,
                "x": "540",
                "y": "346",
                "row": "T",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921294,
                "x": "557",
                "y": "346",
                "row": "T",
                "col": "30",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921295,
                "x": "574",
                "y": "346",
                "row": "T",
                "col": "31",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921296,
                "x": "591",
                "y": "346",
                "row": "T",
                "col": "32",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921297,
                "x": "608",
                "y": "346",
                "row": "T",
                "col": "33",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921298,
                "x": "625",
                "y": "346",
                "row": "T",
                "col": "34",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921299,
                "x": "642",
                "y": "346",
                "row": "T",
                "col": "35",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921300,
                "x": "132",
                "y": "295",
                "row": "Q",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921301,
                "x": "149",
                "y": "295",
                "row": "Q",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921302,
                "x": "166",
                "y": "295",
                "row": "Q",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921303,
                "x": "183",
                "y": "295",
                "row": "Q",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921304,
                "x": "200",
                "y": "295",
                "row": "Q",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921305,
                "x": "217",
                "y": "295",
                "row": "Q",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921306,
                "x": "251",
                "y": "295",
                "row": "Q",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921307,
                "x": "268",
                "y": "295",
                "row": "Q",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921308,
                "x": "285",
                "y": "295",
                "row": "Q",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921309,
                "x": "302",
                "y": "295",
                "row": "Q",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921310,
                "x": "319",
                "y": "295",
                "row": "Q",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921311,
                "x": "336",
                "y": "295",
                "row": "Q",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921312,
                "x": "353",
                "y": "295",
                "row": "Q",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921313,
                "x": "370",
                "y": "295",
                "row": "Q",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921314,
                "x": "387",
                "y": "295",
                "row": "Q",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921315,
                "x": "404",
                "y": "295",
                "row": "Q",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921316,
                "x": "421",
                "y": "295",
                "row": "Q",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921317,
                "x": "455",
                "y": "295",
                "row": "Q",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921318,
                "x": "472",
                "y": "295",
                "row": "Q",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921319,
                "x": "489",
                "y": "295",
                "row": "Q",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921320,
                "x": "506",
                "y": "295",
                "row": "Q",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921321,
                "x": "523",
                "y": "295",
                "row": "Q",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921322,
                "x": "540",
                "y": "295",
                "row": "Q",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921323,
                "x": "132",
                "y": "312",
                "row": "R",
                "col": "7",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921324,
                "x": "149",
                "y": "312",
                "row": "R",
                "col": "8",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921325,
                "x": "166",
                "y": "312",
                "row": "R",
                "col": "9",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921326,
                "x": "183",
                "y": "312",
                "row": "R",
                "col": "10",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921327,
                "x": "200",
                "y": "312",
                "row": "R",
                "col": "11",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921328,
                "x": "217",
                "y": "312",
                "row": "R",
                "col": "12",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921329,
                "x": "251",
                "y": "312",
                "row": "R",
                "col": "13",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921330,
                "x": "268",
                "y": "312",
                "row": "R",
                "col": "14",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921331,
                "x": "285",
                "y": "312",
                "row": "R",
                "col": "15",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921332,
                "x": "302",
                "y": "312",
                "row": "R",
                "col": "16",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921333,
                "x": "319",
                "y": "312",
                "row": "R",
                "col": "17",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": 155,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921334,
                "x": "336",
                "y": "312",
                "row": "R",
                "col": "18",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921335,
                "x": "353",
                "y": "312",
                "row": "R",
                "col": "19",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921336,
                "x": "370",
                "y": "312",
                "row": "R",
                "col": "20",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921337,
                "x": "387",
                "y": "312",
                "row": "R",
                "col": "21",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921338,
                "x": "404",
                "y": "312",
                "row": "R",
                "col": "22",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921339,
                "x": "421",
                "y": "312",
                "row": "R",
                "col": "23",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921340,
                "x": "455",
                "y": "312",
                "row": "R",
                "col": "24",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921341,
                "x": "472",
                "y": "312",
                "row": "R",
                "col": "25",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921342,
                "x": "489",
                "y": "312",
                "row": "R",
                "col": "26",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921343,
                "x": "506",
                "y": "312",
                "row": "R",
                "col": "27",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921344,
                "x": "523",
                "y": "312",
                "row": "R",
                "col": "28",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            },
            {
                "id": 41921345,
                "x": "540",
                "y": "312",
                "row": "R",
                "col": "29",
                "gate": "LEVEL 1",
                "section": "BLOCK 9",
                "seatTypeId": 135,
                "priceZoneId": 660,
                "blockTypeId": null,
                "remarkId": null,
                "status": "OPEN"
            }
        ]
    }
    )
  })
  /* return request({
    url: `/utsvInternet/internet/api/event/${eventId}/performance/${perfId}/seatsInfo/${seatsId}?_=${Date.now()}`,
    method: 'GET',
    headers
  }) */
}